import * as React from 'react';
import { Button } from "primereact/button";

const alphaEnIndex = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];
const alphaBgIndex = ['А', 'Б', 'В', 'Г', 'Д', 'Е', 'Ж', 'З', 'И', 'Й', 'К', 'Л', 'М', 'Н', 'О', 'П', 'Р', 'С', 'Т', 'У', 'Ф', 'Х', 'Ц', 'Ч', 'Ш', 'Щ', 'Ъ', 'Ю', 'Я'];

const alphabeticalFilter = (props) => {
  const enFilter = props.filters.indexOf('en') > -1 ?
    alphaEnIndex.map(letter => {
      return (
        props.buttonStyle ?
          <Button
            key={letter}
            className={props.letterClassName}
            style={props.activeLetter && props.activeLetter.toLowerCase() == letter.toLowerCase() ?
              { marginRight: "5px", marginBottom: "5px", fontSize: '10px', backgroundColor: '#7fbcec', borderColor: '#7fbcec' } :
              { marginRight: "5px", marginBottom: "5px", fontSize: '10px' }}
            label={letter}
            onClick={(e) => props.handleAlphaIndexChange(e, letter)}
          /> :
          <a key={letter} href='' onClick={(e) => props.handleAlphaIndexChange(e, letter)}
            className={props.letterClassName}>
            {letter}
          </a>
      )
    }) : null;

  const bgFilter = props.filters.indexOf('bg') > -1 ?
    alphaBgIndex.map(letter => {
      return (
        props.buttonStyle ?
          <Button
            key={letter}
            className={props.letterClassName}
            style={props.activeLetter && props.activeLetter.toLowerCase() == letter.toLowerCase() ?
              { marginRight: "5px", marginBottom: "5px", fontSize: '10px', backgroundColor: '#7fbcec', borderColor: '#7fbcec' } :
              { marginRight: "5px", marginBottom: "5px", fontSize: '10px' }}
            label={letter}
            onClick={(e) => props.handleAlphaIndexChange(e, letter)}
          /> :
          <a key={letter} href='' onClick={(e) => props.handleAlphaIndexChange(e, letter)}
            className={props.letterClassName}>
            {letter}
          </a>
      )
    }) : null;

  return (
    <div>
      {props.filters.indexOf('en') > -1 ?
        props.buttonStyle ?
          <div style={{ marginBottom: '5px' }}>
            {enFilter}
          </div> :
          <div>
            {enFilter}
          </div>
        : null}
      {props.filters.indexOf('bg') > -1 ?
        <div style={{ marginBottom: '5px' }}>
          {bgFilter}
        </div> : null}
    </div>
  )
}

export default alphabeticalFilter;